module.exports = __webpack_public_path__ + "static/howto2.c73d6205.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/howto2.svg
// module id = 368
// module chunks = 221374088121123